const Schema = () => ({
  title: 'Image Carousel',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['slides'],
    },
  ],
  properties: {
    slides: {
      title: 'Slides',
      widget: 'object_list',
      schema: {
        title: 'Slide',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['image', 'alt', 'link', 'text'],
          },
        ],
        properties: {
          image: {
            title: 'Image',
            widget: 'object_browser',
            mode: 'image',
            allowExternals: true,
          },
          alt: {
            title: 'Alt text',
            widget: 'text',
          },
          link: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
            selectedItemAttrs: ['Title', 'Description'],
          },
          text: {
            title: 'Text',
            widget: 'text',
          },
        },
        required: [],
      },
    },
  },
  required: [],
});

export default Schema;